export const paramCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
export const url = "./api/v1"
export const tokenurl = "./routing/getBearerToken"
export const authvurl = "./backendService"
export const logoutUrl = "./logout"
